// extracted by mini-css-extract-plugin
export default {"answer-wrapper":"qna_answer-wrapper__D4E6V"};